import React from 'react';

import { formatMoney, formatOverAmount, formatWholeMoney } from '~support-at-home/lib/budgetFormat';

interface ComponentProps {
  value: number;
  /** An amount over a limit: at least $1 when above zero. */
  over?: boolean;
}

/** Whole dollars, with the exact amount on hover (rule 7). */
const WholeMoney: React.FC<ComponentProps> = ({ value, over = false }) => (
  <span className="whole-money" title={formatMoney(value)}>
    {over ? formatOverAmount(value) : formatWholeMoney(value)}
  </span>
);

/** For transforms written in .ts (FigureTileItem.value, legend values): the same element. */
export const wholeMoney = (value: number, over = false): React.ReactElement => <WholeMoney value={value} over={over} />;

export default WholeMoney;
